import Rive from "@rive-app/webgl2-advanced";
import type { RiveCanvas } from "@rive-app/webgl2-advanced";
import riveWasmUrl from "@rive-app/webgl2-advanced/rive.wasm?url";

/** The page's runtime, loading or loaded; reset by a failed load so the next caller tries again. */
let loading: Promise<RiveCanvas> | null = null;

/**
 * The page's one Rive runtime — Rive's low-level WebGL2 build, its wasm served with the game (nothing fetched from Rive's
 * CDN) — shared by every Rive view in the game (the chef, the background). The title's own until the engine's Rive entry
 * (`@slot/presentation/rive`) offers the same.
 */
export function riveRuntime(): Promise<RiveCanvas> {
  loading ??= Rive({ locateFile: () => riveWasmUrl }).catch((error: unknown) => {
    loading = null;
    throw error;
  });
  return loading;
}
